/* eslint-disable react/destructuring-assignment */
import { Route } from 'react-router-dom'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import { ErrorBoundaryWithContext } from 'Components/ErrorBoundaryWithContext'
import type { RouteConfig, ContainerRouteConfig } from 'TypeDefs/Route'
import WithOrgConfig from 'Components/SharedComponents/WithOrgConfig/WithOrgConfig'
import { WithGlobalRedirects } from 'Components/SharedComponents/WithGlobalRedirects/WithGlobalRedirects'

interface RouteConfigProp extends RouteConfig {
  loginHint?: string
}

interface ContainerRouteConfigProp extends ContainerRouteConfig {
  loginHint?: string
}

const SentryRoute = Sentry.withSentryRouting(Route)

const RouteWithSubRoutes = (
  route: RouteConfigProp | ContainerRouteConfigProp
) => {
  //  eslint-disable-next-line
  const ComponentWithAuthAndConfig =
    route.access === 'USER'
      ? withAuthenticationRequired(
          WithOrgConfig(
            WithGlobalRedirects(route.Component, {
              isPublic: false,
            })
          )
        )
      : WithOrgConfig(
          WithGlobalRedirects(route.Component, {
            isPublic: route.access === 'PUBLIC',
          })
        )

  if ('routes' in route) {
    return (
      <SentryRoute path={route.path} exact={route.exact}>
        <ErrorBoundaryWithContext>
          <ComponentWithAuthAndConfig routes={route.routes} />
        </ErrorBoundaryWithContext>
      </SentryRoute>
    )
  }

  return (
    <ErrorBoundaryWithContext>
      <SentryRoute
        path={route.path}
        exact={route.exact}
        component={ComponentWithAuthAndConfig}
      />
    </ErrorBoundaryWithContext>
  )
}
export default RouteWithSubRoutes
